// Cross-service time-overlap detection — canonical implementation lives in
// @vertu/shared/booking-core (parity Phase 0.5) so the widget and the staff
// app share one engine. This module keeps the historical import path.

import { useMemo } from "react";
import { getBusyIntervals, type BusyInterval } from "@vertu/shared";
import type { WidgetService } from "../types";
import type { CartItem } from "./cart";

export {
  getBusyIntervals,
  findOverlap,
  suggestNextFreeSlot,
  formatSuggestion,
  type BusyInterval,
  type ConflictableItem,
} from "@vertu/shared";

// Cart-aware slot picking: busy intervals from the items in the cart,
// excluding any for THIS service (so changing your own time doesn't see
// itself as a conflict). A stay is meant to coexist with everything you do
// during it, so overlaps involving accommodation are never a conflict: the
// accommodation panel warns about nothing, and getBusyIntervals already drops
// accommodation cart items for every other panel. Moved from ServicePanel.tsx
// with zero behaviour change.
export function useServiceBusyIntervals(
  cartItems: CartItem[],
  service: Pick<WidgetService, "id" | "service_type">,
): BusyInterval[] {
  return useMemo(
    () =>
      service.service_type === "accommodation"
        ? []
        : getBusyIntervals(cartItems.filter((i) => i.serviceId !== service.id)),
    [cartItems, service.id, service.service_type],
  );
}
